module.exports = __webpack_public_path__ + "media/assets/images/category/CheerUp@2x-55996d21338d4ed04ca38eb7355a83f2.png";